import './error.css'
import {useNavigate} from "react-router";
import {Button} from "suus-component-library";

export default function Error() {

    const navigate = useNavigate();

    const navigateToHome = () => {
        navigate('/home');
    }

    return (
        <div className="content-child-max">
            <div className="content-child-middle content-general">
                <h1>Oops!</h1>

                <div className="content-centered">
                    <p>Sorry, da ist uns ein Fehler unterlaufen.</p>
                    <Button
                        label="Zurück zur Homepage"
                        variant="primary"
                        colorToken="--color-juice-sugarcane"
                        onClick={navigateToHome}
                    />
                </div>
            </div>
        </div>
    );
}
